import { Box, Grid } from '@mui/material';
import { GOOGLE_MAPS_API_KEY } from '../../../../utils/env';

import {
  Container,
  SectionTitle,
  FieldLabel,
  FieldValue,
} from './styles';

interface DetailItemProps {
  label: string;
  value: string;
}

const DetailItem: React.FC<DetailItemProps> = ({ label, value }) => (
  <Box>
    <FieldLabel>{label}</FieldLabel>
    <FieldValue>{value}</FieldValue>
  </Box>
);

interface FacilityDetailsProps {
  facilityName: string;
  address: string;
  latitude?: number | string;
  longitude?: number | string;
}

const FacilityDetails: React.FC<FacilityDetailsProps> = ({ facilityName, address, latitude, longitude }) => {

  return (
    <Container>
      <SectionTitle>Facility Details</SectionTitle>
      <Grid container spacing={3}>
        <Grid size={12}>
          <DetailItem label="Facility Name" value={facilityName} />
        </Grid>
        <Grid size={12}>
          <DetailItem label="Address" value={address || "Not specified"} />
        </Grid>
      </Grid>

      {latitude && longitude &&
        <Box mt={2}>
          <img
            src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=14&size=400x200&markers=color:red|${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`}
            alt="Facility Location Map"
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', display: 'block' }}
          />
        </Box>
      }
    </Container>
  );
};

export default FacilityDetails;
